import { NavItems } from 'components/Header/components/Navigation/Navigation.helpers';
import { reportsTargetingRules } from 'scenes/Report/Report.mock';

const navItems: NavItems[] = [
  {
    label: 'Overview',
    path: '/overview',
    key: 'overview',
    userTypes: ['enterprise', 'demo', 'tier3'],
  },
  {
    label: 'Lift',
    path: '/lift',
    key: 'lift',
    userTypes: ['demo'],
  },
  {
    label: 'Venues',
    path: '/venues',
    key: 'venues',
    userTypes: ['enterprise', 'demo', 'tier3'],
  },
  {
    label: 'Reports',
    path: '/reports',
    key: 'reports',
    userTypes: ['enterprise', 'demo'],
    targetingRules: reportsTargetingRules,
  },
  {
    label: 'Account Management',
    path: '/account-management',
    key: 'account-management',
    userTypes: ['tier3'],
  },
];

export { navItems };
